import { useHistory } from 'react-router'

export const useRouterApi = () => {
  return useHistory()
}
